'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    B10: '#3899ec',
    B40: '#daeffe',
    D20: '#20455e',
    D40: '#7a92a5',
    D50: '#b6c1cd',
    D60: '#dfe5eb',
    D70: '#f0f4f7',
    D80: '#ffffff',
    G10: '#60bc57'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/utils/colors.js
// module id = 120
// module chunks = 0